module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl3-50.bc3451bf.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl3-50.png
// module id = 3550
// module chunks = 11